// export const AUTH_CONFIG = {
//     domain: 'gophr.auth0.com',
//     clientId: '08DTSFzoagUGkvFibKF8h1Bo8tuXJzBA',
//     callbackUrl: 'http://localhost:3000/callback',
//     container: 'auth0-login-container',
//     audience: 'https://gophr.app'
//   }
import config from '../config';
export const AUTH_CONFIG = config.config.AUTH_CONFIG;

  // export const AUTH_CONFIG = {
  //   domain: 'gophr-dev.auth0.com',
  //   clientId: 'R8Lux0ToGL7R7Jky66Ue1mshz2ZOEDzc',
  //   callbackUrl: 'http://localhost:3000/callback',
  //   container: 'auth0-login-container',
  //   audience: 'https://dev.gophr.app',
  //   jwksUri: "https://gophr-dev.auth0.com/.well-known/jwks.json",
  //   algorithms: ["RS256"],
  //   issuer: "https://gophr-dev.auth0.com/",
  //   client: null
  // }



